import useSisenseShowAllTimesDropdown from "./UseSisenseShowAllTimesDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseShowAllTimesDropdown = ({ label, name, value, error, message, onChange }) => {
  const { showAllTimesOptions } = useSisenseShowAllTimesDropdown();

  return showAllTimesOptions.options?.length === 0
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={showAllTimesOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={showAllTimesOptions.options?.length === 0}
      />
    );
};

export default SisenseShowAllTimesDropdown;